module.exports = __webpack_public_path__ + "static/img/RWC_Logo_Casino-Resort-RGB-KO.b98c728.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brands/rwc/RWC_Logo_Casino-Resort-RGB-KO.png
// module id = 26PF
// module chunks = 1